<template>
  <div>
    <template v-for="feature in selectedFeatures">
      <LTileLayer
        layer-type="overlay"
        v-for="(url, index) in feature.urls"
        :key="`${feature.key}-${index}`"
        :url="url"
        :options="getOptions(feature.key)"
      />
    </template>
    <LTileLayer
      v-if="isShinsuishin"
      url="https://s3.ap-northeast-1.amazonaws.com/ctie.hachioji.web/static/tile/sinsoulabel/{z}/{x}/{y}.png"
    />
  </div>
</template>

<script>
import { LTileLayer } from "vue2-leaflet";

export default {
  name: "TerrainFeatureLayer",
  components: { LTileLayer },
  computed: {
    selectedFeatures() {
      return this.$store.getters.selectedFeatures;
    },
    isShinsuishin() {
      const keys = this.selectedFeatures.map(f => f.key);
      return keys.includes("shinsuishin");
    }
  },
  methods: {
    getOptions(key) {
      const options = {
        opacity: 0.8,
        zIndex: 3
      };
      if (key === "shinsuishin") {
        Object.assign(options, {
          maxNativeZoom: 17,
          maxZoom: 18
        });
      }
      return options;
    }
  }
};
</script>
